import React, {useEffect, useState} from "react";
import {Grid} from "@mui/material";
import Box from "@mui/material/Box";
import {ObjectViewMediaSection} from "./ObjectViewMediaSection";
import {useObserveWindowResize} from "../app/useObserveWindowResize";

/**
 * Wrapper used to adapt the object view media section to a small or large screen.
 * @param smallScreen   bool    True, if displayed on a small screen
 * @param columnDefs    Array   Array of column defs [left, right]
 * @param gridRef   ref Reference to the media section container
 * @param handleMediaPlayClick function Callback when play icon is clicked
 * @returns {JSX.Element}
 * @constructor
 */
export const ObjectViewMediaSectionWrapper = ({
                                                  smallScreen,
                                                  columnDefs,
                                                  gridRef,
                                                  t,
                                                  mediaPlayCallback,
                                                  pdfOpenedCallback
                                              }) => {
    const observeWindowResize = useObserveWindowResize(undefined);
    const [isPortrait, setIsPortrait] = useState(true);

    useEffect(() => {
        setIsPortrait(observeWindowResize.width < observeWindowResize.height);
    }, [observeWindowResize.width, observeWindowResize.height]);

    // Styles for the small-screen media box, adapting to portrait vs landscape
    const smallScreenBoxSx = isPortrait
        ? {
            display: "flex",
            width: "100%",
            justifyContent: "center",
            height: "30vh",
            maxHeight: "30vh",
            backgroundColor: "#ddd",
            overflow: "hidden",
        }
        : {
            display: "flex",
            width: "30%",
            minWidth: "30%",
            minHeight: "100vh",
            alignContent: "center",
            justifyContent: "center",
            backgroundColor: "#ddd",
            overflow: "hidden",
        };

    return (
        <>
            {!smallScreen && (
                <Grid ref={gridRef} size={{md: columnDefs[0]}}>
                    <Box
                        sx={{
                            display: "flex",
                            width: "100%",
                            height: "100%",
                            justifyContent: "center",
                        }}
                    >
                        <ObjectViewMediaSection
                            t={t}
                            gridRef={gridRef}
                            mediaPlayCallback={mediaPlayCallback}
                            smallScreen={smallScreen}
                            pdfOpenedCallback={pdfOpenedCallback}
                        />
                    </Box>
                </Grid>
            )}
            {smallScreen && (
                <Box sx={smallScreenBoxSx}>
                    <ObjectViewMediaSection
                        gridRef={gridRef}
                        mediaPlayCallback={mediaPlayCallback}
                        smallScreen={smallScreen}
                        t={t}
                        pdfOpenedCallback={pdfOpenedCallback}
                    />
                </Box>
            )}
        </>
    );
};
